import {hash_map, keyword, resolveGoogExport} from 'dgetz/tsclj'

export function ImoSummerSizzleBonusEarnings({summerSizzleBonusInfo, summerSizzleTermsUrl}) {
  const {imo_summer_sizzle_bonus_earnings} = resolveGoogExport('ladder.agents.dashboard.incentives')
  return !!summerSizzleBonusInfo && !!summerSizzleTermsUrl &&
    imo_summer_sizzle_bonus_earnings(hash_map(
      keyword('info'), summerSizzleBonusInfo,
      keyword('terms-url'), summerSizzleTermsUrl),
    )
}
